import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import PageLoader from '../../../../../components/PageLoader';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { categories } from '../../../../../redux/categories/action';
import { products } from '../../../../../redux/products/action';
import { selectListItems } from '../../../../../redux/library/selector';
import * as R from 'ramda'
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectTenantFunctionsListItems } from '../../../../../redux/tenant-functions/selector';
import { tenantFunctions } from '../../../../../redux/tenant-functions/action';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import { selectProductsListItems } from '../../../../../redux/products/selector';
import SocialProfilesComponent from '../components/social-profiles.component';
import { socialProfiles } from '../../../../../redux/social-profiles/action';
import { selectSocialProfilesQueryItems } from '../../../../../redux/social-profiles/selector';
import { selectTemplatesListItems } from '../../../../../redux/templates/selector';
import storePersist from '../../../../../redux/storePersist';

let currentChange: any = {}
const ManagementSocialProfile = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector((selectSocialProfilesQueryItems))
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productsLists = useSelector(selectProductsListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const channelLists = useSelector(selectListItems)
  const templatesItems = useSelector(selectTemplatesListItems)
  const websitesItems = useSelector(selectWebsitesListItems)
  const webPagesItems = useSelector(selectAccountWebPagesListItems)
  const accountItems = useSelector(selectAccountsListItems)
  const librariesItems = storePersist?.get("library")?.current;
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedSocialProfiles, setSelectedSocialProfiles] = useState<any>({
    BodyContent: '',
    DesignFileurls: [],
    Attachmenturls: [],
    MappedEntities: []
  })
  const [
    selectedFunctions,
    setSelectedFunctions
  ] = useState<any>([])




  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const fetchSocialProfileId = () => {
    dispatch(socialProfiles.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles/query`,
      entity: 'socialProfiles', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  useEffect(
    () => {
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
        }
      })).then(() => {
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          }
        }))
      }).then(() => {
        dispatch(categories.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
          entity: 'categories',
          jsonData: {

          }
        }))
      }).then(() => {
        dispatch(products.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
          entity: 'products',
          jsonData: {
          }
        }))
      }).then(() => {
        dispatch(accounts.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
          entity: 'accounts',
          jsonData: {
            Context: {},
            Records: [
              {
                IsProxyAccount: false
              }
            ],
            Pagination: {
            }

          }
        }))
      }).then(() => {
        dispatch(tenantFunctions.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantDomainFunctions', jsonData: {
            Filters: [
              {
                FieldName: 'IsTemplateMappingEnabled',
                FieldText: 'TemplateMappingEnabled',
                FieldType: 'boolean',
                FilterOperatorId: 1,
                FieldValue: true
              }
            ]


          }
        }))
      })
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {

        }
      }));
      if (parmas?.id > 0) {
        fetchSocialProfileId()
        setIsLoading(false)
      }
      else {
        const localSelectedFunction = addNewRow({ selectedFunctionArg: selectedFunctions });
        setSelectedFunctions(localSelectedFunction)


        setIsLoading(false)
      }
    },
    []
  )


  useEffect(
    () => {

      if (isQuery) {
        setSelectedSocialProfiles(queryItems?.result?.items)
        const localSelectedService = addNewRow({ selectedFunctionArg: queryItems?.result?.items?.MappedEntities });
        setSelectedFunctions(localSelectedService)


      }
    },
    [isQuery]
  )
  const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  const deleteSelectedFunctions = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      selectedFunctions?.splice(
        index,
        1
      )
    }
    handleClose()
  }
  const addNewRow = ({ selectedFunctionArg }: any) => {
    const localSelectedFunction = deepCopy(selectedFunctionArg)
    const newsFunctions = {
      Id: 0,
      OwnerTypeId: 0,
      OwnerId: 0,


    }
    if (localSelectedFunction.length === 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerId !== ''
    ) {
      localSelectedFunction?.push(newsFunctions)
    }

    return localSelectedFunction
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedSocialProfiles({ ...selectedSocialProfiles, [field]: event });
  }
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedFunctions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedFunctions(items);
  }







  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    selectedSocialProfiles.IsApproved = true;
    selectedFunctions.splice(
      selectedFunctions.length - 1,
      1
    );
    mediaFiles?.splice(
      mediaFiles.length - 1,
      1
    )

    const mediaData: any = mediaFiles?.map((item: any) => {
      const itemData = {
        attachementURL: item?.FileMappingURL
      }
      return itemData
    })

    selectedSocialProfiles.Attachmenturls = mediaData.map((data: any) => data.attachementURL);

    selectedSocialProfiles.MappedEntities = selectedFunctions
    if (parmas?.id > 0) {
      await dispatch(socialProfiles.resetAction({ actionType: 'update' }))
      await dispatch(socialProfiles.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles`,
        entity: 'socialProfiles',
        jsonData: {
          Records: [
            selectedSocialProfiles
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(socialProfiles.resetAction({ actionType: 'create' }))
      await dispatch(socialProfiles.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/social-profiles`,
        entity: 'socialProfiles', jsonData: {
          Records: [
            selectedSocialProfiles
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const setCombinationInfo = async () => {
    let localSelectedFunction = deepCopy(selectedFunctions)
    localSelectedFunction.splice(
      currentChange.idx,
      1,
      { ...localSelectedFunction[currentChange.idx] }
    );
    localSelectedFunction = addNewRow({ selectedFunctionArg: localSelectedFunction });
    currentChange.field = 'OwnerTypeIdDONE'
    setSelectedFunctions(localSelectedFunction)
  }

  useEffect(
    () => {
      if (currentChange.field === 'OwnerId') {
        setCombinationInfo()
      }
    },
    [selectedFunctions]
  )
  const back = () => {
    navigate('/management/cms/social-profiles')
  }

  useEffect(() => {

  }, [selectedSocialProfiles]
  )


  const formatWebpagesListData = (data: any) => {
    return _.map(data, (product: any) => {
      const item = {
        Id: product?.Id,
        WebpageName: `${product?.Name} : ${product?.AccountName}`,
      };
      return item
    });
  };
  return (
    <>

      {isLoading ? <PageLoader /> :
        <SocialProfilesComponent
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
          selectedSocialProfiles={selectedSocialProfiles}
          socialProfileType={librariesItems?.SocialProfileType}
          selectedFunctions={selectedFunctions}
          categories={categoriesLists?.result?.items}
          accounts={accountItems?.result?.items}
          channels={channelLists?.result?.items}
          organizationUnits={organizationUnitsLists?.result?.items}

          products={productsLists?.result?.items}
          handleFormItemChange={handleFormItemChange}
          deleteSelectedFunctions={deleteSelectedFunctions}
          tenantFunction={tenantfunctionsLists?.result?.items}
          templates={templatesItems?.result?.items}
          id={parmas?.id}

          mediaFiles={mediaFiles}
          handleFormAttachmentItemChange={handleFormAttachmentItemChange}
          websites={websitesItems?.result?.items}
          webpages={formatWebpagesListData(webPagesItems?.result?.items)}
          tenantFunctions={(tenantfunctionsLists?.result?.items || []).flatMap(
            (func: any) =>
              (func.Entities || []).map((entity: any) => ({
                label: entity.EntityName,       // what to show in dropdown
                value: entity.Id,               // OwnerTypeId
                FunctionName: func.FunctionName, // used for conditional logic
              })))}

        />}
    </>
  )

}

export default ManagementSocialProfile;